<script lang="ts">
  import { fade } from "svelte/transition";
  import Portal from "svelte-portal/src/Portal.svelte";
  import { toggleCart, cartItemCount } from "../stores/cart";
</script>

<Portal target="#cart-button">
  <div class="flex items-center h-full">
    <button class="relative text-olli-500" on:click={() => toggleCart()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
      {#if $cartItemCount > 0}
        <span
          transition:fade
          class="absolute -bottom-2 -right-2 flex items-center justify-center w-4 h-4 bg-olli-500 rounded-full text-[0.5rem] text-white font-bold"
          >{$cartItemCount < 100 ? $cartItemCount : "99+"}</span
        >
      {/if}
    </button>
  </div>
</Portal>
